module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n"